import { render, staticRenderFns } from "./valmistumispyynnot-virkailija.vue?vue&type=template&id=af3b5e3a&scoped=true&"
import script from "./valmistumispyynnot-virkailija.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynnot-virkailija.vue?vue&type=script&lang=ts&"
import style0 from "./valmistumispyynnot-virkailija.vue?vue&type=style&index=0&id=af3b5e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3b5e3a",
  null
  
)

export default component.exports